import { useMemo } from 'react'
import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'
import { getRecommendationPlaceIdsForVariant, getSearchedPlaces } from 'lib/search/searchedPlaces'

const MIN_DISTINCT_PLACE_IDS_TO_ACTIVATE = 3

function useRecommendationPlaceIds(): Array<string> {
  const distinctPlaceIds = new Set(
    getSearchedPlaces({ excludeAnywhere: true }).map(place => place.placeId),
  )
  const hasEnoughPlaces = distinctPlaceIds.size >= MIN_DISTINCT_PLACE_IDS_TO_ACTIVATE
  const { variation } = useExperiment(Experiments.searchRecommendationSuggestions, {
    canActivate: hasEnoughPlaces,
  })

  return useMemo(
    () => hasEnoughPlaces ? getRecommendationPlaceIdsForVariant(variation) : [],
    [variation, hasEnoughPlaces],
  )
}

export default useRecommendationPlaceIds
